document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartFooter', () => {
    return {
      footerRoot: null,
      _morphFooter(e) {
        const newFooterSection = querySelectorInHTMLString(
          '[data-cart-footer]',
          e.detail.response.sections['cart-footer']
        );

        Alpine.morph(
          this.footerRoot,
          newFooterSection ? newFooterSection.outerHTML : '',
          {
            updating(el, toEl, childrenOnly, skip) {
              if (
                el.classList &&
                el.classList.contains('additional-checkout-buttons')
              ) {
                skip();
              }
            },
          }
        );
      },
      init() {
        this.footerRoot = this.$root;

        window.addEventListener('cascade:modalcart:afteradditem', (e) => {
          this._morphFooter(e);
        });

        window.addEventListener('cascade:modalcart:cartqtychange', (e) => {
          this._morphFooter(e);
        });
      },
      checkoutButton(e) {
        if (document.getElementById("agree").checked) {
          document.querySelector('.tc-error').classList.add('hide');
          const checkoutButton = document.querySelector('button[name="checkout"]');
          checkoutButton.removeAttribute('@click.prevent');
          var url = "https://" + window.location.hostname + '/checkout'
          window.location.href = url;
        } else {
          document.querySelector('.tc-error').classList.remove('hide');
        }
      },
    };
  });
});